import axios from 'axios'

export default {
  state: {
    masterlogs: [],
    parents: [],
    students: [],
    teachers: [],
    systemNotifications: []

  },
  mutations: {
    setLogs(state, payload) {
      state.masterlogs = payload
    },
    setParents(state, payload) {
      state.parents = payload
    },
    setStudents (state, payload) {
      state.students = payload
    },
    setTeachers(state, payload) {
      state.teachers = payload
    },
    setSystemNotifications(state, notifications) {
      state.systemNotifications = notifications
    }
  },
  actions: {
    // doesn't require jwt token
    getSystemNotifications({ commit }) {
      axios.get('/api/system-notifications').then((response) => {
        commit('setSystemNotifications', response.data.notifications)
      })
    },
    // not being used atm
    createNotification({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/api/system-notifications', payload).then((response) => {
          commit('setSystemNotifications', response.data.notifications)
          resolve()
        })
        .catch((e) => {
          commit('setValidationErrors', e)
          reject()
        })  
      })      
    },
    updateNotification({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.put('/api/system-notifications/' + payload.id, payload).then((response) => {
          commit('setSystemNotifications', response.data.notifications)
          resolve()
        })
        .catch((error) => {
          dispatch('checkToken', error).then(() => {
            commit('setValidationErrors', error)
            reject()
          })
          
        })
      })
    },
    getMasterLogs({ commit, dispatch }, semester) {
      axios.get('/api/masterlogs/' + semester).then((response) => {
        commit('setLogs', response.data.logs)
      })
      .catch((error) => {
        dispatch('checkToken', error)
      })
    },
    getParents({ commit, dispatch }) {
      axios.get('/api/users/parents').then((response) => {
        commit('setParents', response.data.parents)
      })
      .catch((error) => {
        dispatch('checkToken', error)
      })
    },
    updateParent({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.put('/api/users/parents/' + payload.id, payload).then((response) => {
          commit('setParents', response.data.parents)
          resolve()
        })
        .catch((error) => {
          dispatch('checkToken', error).then(() => reject(error))
        })
      })
    },
    deleteParent({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        axios.delete('/api/users/parents/' + id).then((response) => {
          commit('setParents', response.data.parents)
          resolve()
        })
        .catch((error) => {
          dispatch('checkToken', error).then(() => reject(error))
        })
      })
    },
    getStudents({ commit, dispatch }) {
      axios.get('/api/students').then((response) => {
        commit('setStudents', response.data.students)
      })
      .catch((error) => {
        dispatch('checkToken', error)
      })
    },
    createStudent({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/api/students', payload).then(() => {
            dispatch('getStudents')
            resolve()
          })
          .catch((error) => {
            dispatch('checkToken', error).then(() => reject(error))
          })
      })
    },
    updateStudent({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.put('/api/students/' + payload.id, payload).then(() => {
          dispatch('getStudents')
          resolve()
        })
        .catch((error) => {
          dispatch('checkToken', error).then(() => reject(error))
        })
      })
    },
    deleteStudent({ dispatch }, id) {
      return new Promise((resolve, reject) => {
        axios.delete('/api/students/' + id).then((response) => {
          dispatch('getStudents')
          resolve()
        })
        .catch((error) => {
          dispatch('checkToken', error).then(() => reject(error))
        })
      })
    },
    incrementStudentGradeLevels({ dispatch }) {
      return new Promise((resolve, reject) => {
        axios.patch('/api/students/update-grade-levels')
          .then(response => {
            dispatch('getStudents')
            resolve()
          })
          .catch(error => {
            dispatch('checkToken', error).then(() => reject(error))
          })
      })
    },
    getTeachers({ commit, dispatch }) {
      axios.get('/api/teachers').then((response) => {
        commit('setTeachers', response.data.teachers)
      })
      .catch((error) => {
        dispatch('checkToken', error)
      })
    },
    createTeacher({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/api/teachers', payload).then((response) => {
          commit('setTeachers', response.data.teachers)
          resolve()
        })
        .catch((error) => {
          dispatch('checkToken', error).then(() => reject(error))
        })
      })
    },
    updateTeacher({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.put('/api/teachers/' + payload.id, payload).then((response) => {
          commit('setTeachers', response.data.teachers)
          resolve()
        })
        .catch((error) => {
          dispatch('checkToken', error).then(() => reject(error))
        })
      })
    },
    deleteTeacher({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        axios.delete('/api/teachers/' + id).then((response) => {
          commit('setTeachers', response.data.teachers)
          resolve()
        })
        .catch((error) => {
          dispatch('checkToken', error).then(() => reject(error))
        })
      })
    },
    adminEnroll({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.put('/api/admin/add-student-to-class', payload).then((response) => {
          commit('setCourseManagerData', response.data.course)
          resolve()
        })
        .catch((error) => {
          dispatch('checkToken', error).then(() => reject(error))
        })
      })
    },
    adminWaitlist({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.put('/api/admin/add-student-to-waitlist', payload).then((response) => {
          commit('setCourseManagerData', response.data.course)
          resolve()
        })
        .catch((error) => {
          dispatch('checkToken', error).then(() => reject(error))
        })
      })
    },
    adminDropFromClass({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.put('/api/admin/drop-student-from-class', payload).then((response) => {
          commit('setCourseManagerData', response.data.course)
          resolve()
        })
        .catch((error) => {
          dispatch('checkToken', error).then(() => {
            commit('setResponseStatus', error.response)
            reject()
          })
        })
      })
    },
    adminMoveFromWaitlistToClass({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.put('/api/admin/move-from-waitlist-to-enrolled', payload).then((response) => {
          commit('setCourseManagerData', response.data.course)
          resolve()
        })
        .catch((error) => {
          dispatch('checkToken', error).then(() => {
            commit('setResponseStatus', error.response)
            reject()  
          })          
        })
      })
    },
    adminDropFromWaitlist({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.put('/api/admin/drop-student-from-waitlist', payload).then((response) => {
          commit('setCourseManagerData', response.data.course)
          resolve()
        })
        .catch((error) => {
          dispatch('checkToken', error).then(() => {
            commit('setResponseStatus', error.response)
            reject()  
          }) 
        })
      })
    }
  }
}


